export const originalDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export const shortDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const getTodayIndex = () => {
  const today = new Date();
  return (today.getDay() + 6) % 7;
};

export const getToday = () => {
  return originalDays[getTodayIndex()];
};

export const getCurrentDay = () => {
    return originalDays[(new Date().getDay() + 6) % 7];
};